import { useMemo } from 'react';

import { useWoopWorkloadFilters } from 'features/workload-optimization';

import { kindCriterion } from '../searchCriteria';

import { QuickSearchFilter } from '@cast/shared-search-ui';

type Props = {
  optimizedOnly?: boolean;
};

export const KindQuickSearch = (props: Props) => {
  const { data } = useWoopWorkloadFilters({
    optimizedOnly: props.optimizedOnly,
  });
  const kinds = useMemo(() => (data?.kinds ?? []).toSorted(), [data]);

  return (
    <QuickSearchFilter options={kinds} criterion={kindCriterion} multiple />
  );
};
